import { StringHash } from '@app/shared/utils/utils-types';
import { SimpleTopic } from '@app/origami-api/utils/topic-utils';
import { SettingsSubModule } from './settings-sub-module';
import { createSettingsDecorator } from './setting-group-base';
import { Type } from '@angular/core';
import { BaseSettingsModule } from './settings-module-base';

export class SettingsModule extends BaseSettingsModule {
  static value(constructor: Type<SettingsSubModule>) {
    return createSettingsDecorator(function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _this: SettingsModule = this;

      return new constructor(
        _this.mainStore[_this.moduleName],
        _this.defaultStore ? _this.defaultStore[_this.moduleName] : null,
        (fields) =>
          _this.saveData({
            TopicName: _this.moduleName,
            TopicFields: fields,
          }),
      );
    });
  }

  getValues(): StringHash<any> {
    const result = {};
    this.keys.forEach((key) => Object.assign(result, this[key].getValues()));
    return result;
  }

  getDbValues(returnOnlyDirty: boolean = true): SimpleTopic {
    let result = [];
    this.keys.forEach((key) => (result = result.concat(this[key].getDbValues(returnOnlyDirty))));

    return result.length
      ? {
          TopicName: this.moduleName,
          TopicFields: result,
        }
      : null;
  }
}
